import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import BankWithdrawalsContent from '../components/BankWithdrawalsContent';

export default function BankWithdrawals() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="banka-cekim" />
                    <BankWithdrawalsContent />
                </div>
            </div>
        </div>
    );
}
